<template>
  <v-container>
    <v-card>
      <v-container fluid>
        <v-card-title class="text--center"> </v-card-title>

        <v-card-title>
          Gestion Phototéque
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            @keyup.enter="filterKey"
            append-icon="mdi-magnify"
            label="Rechercher"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-skeleton-loader :loading="loading && !options.page" type="table">
          <v-data-table
            :loading="loading"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            loading-text="Veuillez patienter quelques instants "
            :search="search"
            @page-count="pageCount = $event"
            :options.sync="options"
            :server-items-length="totalDocuments"
            :headers="headers"
            :items="dataValues"
            hide-default-footer
            class="elevation-0"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-spacer></v-spacer>
                <v-dialog v-model="dialogs" max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      fab
                      color="primary"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                      ><v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <v-sheet elevation="12" class="pa-12">
                    <v-form
                      class="input--fields__wrapper"
                      ref="create"
                      lazy-validation
                      v-on:submit.prevent="onCreate"
                    >
                      <v-text-field
                        :rules="[rules.required]"
                        label="Titre"
                        v-model="editedItem.imageName"
                      ></v-text-field>

                      <v-file-input
                        :rules="[rules.required]"
                        id="fUploadT"
                        accept="image/jpeg;png"
                        v-model="filesT"
                        placeholder="Thumbnaill"
                        label="Pièces jointes / Thumbnail"
                        prepend-icon="mdi-paperclip"
                      >
                        <template v-slot:selection="{ text, item, selected }">
                          <v-chip
                            :rules="[rules.required]"
                            :input-value="selected"
                            close
                            @click:close="remove(item)"
                            small
                            label
                            color="primary"
                          >
                            {{ text }}
                          </v-chip>
                        </template>
                      </v-file-input>

                      <v-file-input
                        :rules="[rules.required]"
                        id="fUploadS"
                        accept="image/jpeg;png"
                        v-model="files"
                        placeholder="Source"
                        label="Pièces jointes / Src"
                        prepend-icon="mdi-paperclip"
                      >
                        <template v-slot:selection="{ text, item, selected }">
                          <v-chip
                            :rules="[rules.required]"
                            :input-value="selected"
                            close
                            @click:close="remove(item)"
                            small
                            label
                            color="primary"
                          >
                            {{ text }}
                          </v-chip>
                        </template>
                      </v-file-input>

                      <v-overlay :value="overlay">
                        <v-progress-circular
                          indeterminate
                          size="64"
                        ></v-progress-circular>
                      </v-overlay>
                    </v-form>
                  </v-sheet>

                  <v-btn color="primary" @click="onCreate" tile>Créer</v-btn>
                </v-dialog>
              </v-toolbar>
            </template>

            <template v-slot:item.src="{ item }">
              <v-btn
                @click="url(item)"
                class="text-capitalize"
                width="110px"
                color="primary"
                rounded
              >
                Aperçu
              </v-btn>
            </template>
            <template v-slot:item.delete="{ item }">
              <v-icon medium class="ml-5" @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
            <template v-slot:item.thumbnail="{ item }">
              <v-avatar>
                <img :src="item.thumbnail" />
              </v-avatar>
            </template>
          </v-data-table>
        </v-skeleton-loader>

        <div class="class text-center pt-2">
          <v-pagination
            circle
            :total-visible="7"
            v-model="page"
            :length="pageCount"
          ></v-pagination>
        </div>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  components: {},

  methods: {
    resetCreate() {
      this.$refs.create.reset();
    },
    resetUpdate() {
      this.$refs.update.reset();
    },
    checkRendering() {
      this.$store.state.toRender = true;
    },
    url(item) {
      window.open(item.src);
    },
    ApiCall() {
      this.loading = true;
      const { page } = this.options;
      this.$store.dispatch('medias/getGallery', page).then((resp) => {
        this.loading = false;

        this.dataValues = resp.data.allImages;
        this.totalDocuments = resp.data.imagesTotalLength;
      });
    },
    FilterApiCall() {
      this.loading = true;
      const { page } = this.options;
      this.$store
        .dispatch('medias/searchImageGallery', {
          page: page,
          searchData: this.search,
        })
        .then((resp) => {
          this.loading = false;

          this.dataValues = resp.data.allImages;
          this.totalDocuments = resp.data.imagesTotalLength;
        });
    },

    filterKey(event) {
      if (event.keyCode === 13) {
        this.FilterSort();
      }
    },

    extension_checker(tag) {
      const file = document.querySelector(tag);

      for (let index = 0; index < file.files.length; index++) {
        if (/\.(jpe?g|png)$/i.test(file.files[index].name) === false) {
          //change the alert with a function that throws a snackbar or smtng
          alert('Veuillez entrez une extensions valide');
          return false;
        } else {
          return true;
        }
      }
    },

    deleteItem(item) {
      this.overlay = true;
      confirm('Are you sure you want to delete this item?') &&
        this.$store
          .dispatch('medias/deleteImageGallery', { _id: item._id })
          .then((resp) => {
            this.ApiCall();
            this.overlay = false;
          });
    },

    onCreate() {
      if (this.$refs.create.validate()) {
        if (
          this.files &&
          this.extension_checker('#fUploadT') &&
          this.extension_checker('#fUploadS')
        ) {
          let formData = new FormData();

          if (this.files !== null && this.filesT) {
            formData.append('files', this.files, 'src');
            formData.append('files', this.filesT, 'thumbnail');
          }

          // initial values for other inputs
          formData.append('imageName', this.editedItem.imageName);

          this.overlay = true;

          axios({
            url: '/api/V844G3425823F14YG2V2/createImageGallery',
            method: 'POST',
            data: formData,
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
          })
            .then((response) => {
              this.ApiCall();
              this.resetCreate();
              this.overlay = false;

              this.dialogs = false;
            })
            .catch((error) => {});
        }
      }
    },

    FilterSort() {
      if (this.search !== null) {
        this.FilterApiCall();
      } else {
        return false;
      }
    },
  },
  computed: {
    test() {
      return this.$store.state.appels.obj;
    },
  },

  mounted() {
    this.loading = false;
  },

  watch: {
    options: {
      handler() {
        if (this.search !== null) {
          this.FilterApiCall();
        } else {
          this.ApiCall();
        }
      },
      deep: true,
    },
  },

  data: () => ({
    overlay: false,

    search: null,

    rules: {
      required: (value) => !!value || 'Ce champ est obligatoire.',
      min: (v) =>
        v.length >= 8 || 'Le champ doit contenir 8 caractères minimum',
      emailRules: (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        'Veuillez entrer une adresse électronique valide',
    },

    loading: true,

    options: {},
    totalDocuments: 0,
    itemsPerPage: 10,
    page: 1,
    pageCount: 0,
    editedIndex: -1,
    dialog: false,
    defaultItem: {
      _id: '',
      imageName: '',
      thumbnail: '',
      src: '',
    },
    editedItem: {
      _id: '',
      imageName: '',
      thumbnail: '',
      src: '',
    },
    headers: [
      { text: "Titre d'image", value: 'imageName' },

      { text: 'Preview', value: 'thumbnail' },
      {
        text: 'Image',
        value: 'src',
      },
      // { text: "Fichier", value: 'src'},
      { text: 'Supprimer', value: 'delete' },
    ],
    dataValues: [],
    overlay: false,
    flex: [4, 6, 3],
    show: false,

    items: ['Attribué', 'En cours', 'Infructueux', 'Annulé'],

    // Details update

    files: null,
    filesT: null,
    detailId: '',
    detailEtat: '',
    detailDateOpening: '',
    detailEstimation: '',
    detailDateEchant: '',
    detailFrais: '',
    detailDateVisite: '',
    detailCautionnement: '',
    detailObjetAppel: '',
  }),
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Karla:ital@1&family=Montserrat&display=swap');

.input--fields__container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
}

.class {
  background-color: white;
}

.v-chip {
  width: 100px;
  justify-content: center;
}

/* Dialog Styling */

.round {
  border-radius: 30px;
  overflow-y: hidden;
}

@media only screen and (device-width: 1920px) and (device-height: 1080px) {
  .v-card {
    margin-left: 26px !important;
    width: 91%;
  }
}
</style>
